import { ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BlendEvent, User } from '../../models';
import * as fromRoot from '../../../reducers';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Store, select } from '@ngrx/store';
import { ApiService } from 'src/app/core/api.service';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Avatar, BottomSheetComponent, Action, ActionCell, MenuItems } from '@material-library';
import { B64Pipe } from '../../pipes/b64.pipe';
import { TransferService } from 'src/app/transfer/services/transfer.service';
import { SnackbarService } from '../../services/snackbar.service';
import { AppBarActionsService } from '../root-layout/app-bar-actions.service';
import { ActivatedRoute } from '@angular/router';
import { RootLayoutConfigService } from '../root-layout/root-layout-config.service';
import { BlendService } from '../../services/blend.service';
import { ColorContrastService } from '../../services/color-contrast.service'

@Component({
  selector: 'app-links-layout',
  templateUrl: './links-layout.component.html',
  styleUrls: ['./links-layout.component.scss']
})
export class LinksLayoutComponent implements OnInit, OnDestroy {
  @Input() public type: string; // binding from component.

  public pendingShares: number; // user
  public eventCount: number; // user

  public imageCachekey: string; //32-char random string
  // @HostBinding("style.--primaryColor") only works in Angular 9+
  public primaryColor: string;
  public textColor: string;
  public linkColor: string;
  public logoHost: string;
  public buttonPrimaryColor: string;
  public buttonTextColor: string;
  public whiteLabelLoaded: boolean;
  public avatarEndpoint = `${environment.logohost}avatar/`;
  public userLoaded: boolean;

  private sub: Subscription;
  private sub1: Subscription;
  private breakpointSub: Subscription;
  private actionsSub: Subscription;
  private rootConfigSub: Subscription;

  public user: User;
  public openHelpLinkDialog = false;
  public isUserPanelOpen: boolean = false;
  public hasBackdrop: boolean = false;
  public isBottomSheetOpen: boolean = false;
  private avatarSize: number = 48;
  public avatarUrl: string;
  public userAvatar: string;
  public avatarInfo: Avatar;
  public title: string;
  public subTitle: string;
  public allowComment: 0 | 1 | 2 = 0;
  public isCommentExpanded = true;
  public isXsView: boolean = false;
  public isSmView: boolean = false;
  private PAGE_TITLE = 'Sync.com';
  public actionLimit: number|false = false;
  public previewActionCell?: ActionCell;
  public cpHost = environment.cphost;
  public showBackButton: boolean = false;
  
  @ViewChild('bottomSheetComponent')
  bottomSheetComponent!: BottomSheetComponent;
  linkID: any;


  constructor(
    private store: Store<fromRoot.State>,
    private sanitizer: DomSanitizer,
    public breakpointObserver: BreakpointObserver,
    public b64Pipe: B64Pipe,
    public transferService: TransferService,
    public snackbarService: SnackbarService,
    private pageTitleService: Title,
    private appBarActionsService: AppBarActionsService,
    private rootLayoutConfigService: RootLayoutConfigService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private blendService: BlendService,
    private colorService: ColorContrastService
  ) { }

  ngOnInit() {
    if (!this.type) {
      this.type = this.route.snapshot.params['type'];
    }
    this.sub = this.store
      .pipe(select(fromRoot.getAuthState))
      .subscribe((data) => {
        if (data && data.user) {
          this.user = data.user;
          this.userAvatar = this.user?.avatar?.avatar_data;
          this.avatarUrl = this.userAvatar
          ? `${this.avatarEndpoint}${this.user?.id}`
          : '';
          this.updateAvatarInfo(this.avatarUrl);
        } else {
          this.user = null;
          this.userAvatar = null;
          this.avatarUrl = '';
          this.updateAvatarInfo('');
        }
      });

    this.sub1 = this.store
      .pipe(select(fromRoot.getLinkFileListState))
      .subscribe((data) => {
        if (data.whitelabel_loaded) {
          this.imageCachekey = data.image_cachekey;
          this.primaryColor = data.header_primary_color;
          this.textColor = data.header_text_color;
          this.linkColor = data.link_text_color;
          this.buttonPrimaryColor = data.button_primary_color;
          this.buttonTextColor = data.button_text_color;
          this.whiteLabelLoaded = data.whitelabel_loaded;
          this.logoHost = environment.logohost;
        }
        if (data.error && (data.error.code == 8018 || data.error.code == 8019)) {
          this.allowComment = 0;
        } else {
          this.allowComment = data.allow_comment;
        }
        //observe when iframe in comment-block completely loaded
        if (data.iframeReady) {
          this.userLoaded = true;
        }
        // this.log.info('LINK FILE LIST');
        // this.log.info(data);
      });

      this.breakpointSub = this.breakpointObserver
      .observe([
        '(max-width: 904px)',
        '(max-width: 599px)',
        '(max-width: 1239px)',
      ])
      .subscribe((state: BreakpointState) => {
        if (state.breakpoints['(max-width: 599px)']) {
          // If the screen size is less than or equal to 599px  wide,
          // hide side navigation bar, show menu icon in toolbar and enable bottomsheet
          this.hasBackdrop = true;
          this.isBottomSheetOpen = true;
          this.isUserPanelOpen = false;
          this.avatarSize = 32;
          this.isXsView = true;
          this.actionLimit = 1;
        } else if (state.breakpoints['(max-width: 904px)']) {
          // If the screen size is less than or equal to 904px, set the drawer to be always expanded and visible
          this.hasBackdrop = true;
          this.bottomSheetComponent?.dismissBottomSheet();
          this.avatarSize = 32;
          this.isXsView = false;
          this.isSmView = true;
          this.actionLimit = 1;
        } else if (state.breakpoints['(max-width: 1239px)']) {
          this.avatarSize = 40;
          this.isXsView = false;
          this.actionLimit = false;
          this.isSmView = false
        }
        else {
          // If the screen size is greater than 904px, set the drawer to be collapsed and hide bottomsheet
          this.hasBackdrop = false;
          this.isBottomSheetOpen = false;
          this.bottomSheetComponent?.dismissBottomSheet();
          this.avatarSize = 48;
          this.isXsView = false;
          this.actionLimit = false;
          this.isSmView = false;
        }
        if (this.previewActionCell) {
          this.previewActionCell = {...this.previewActionCell};
        }
      });

      this.actionsSub = this.appBarActionsService.currentData.subscribe(data => {
        const defaultActions: Array<Action> = [{
          name: 'Create account',
          onClick: () => window.location.href = 'https://www.sync.com/?_m=h73',
          icon: 'user-circle',
          type: 'primary',
          shouldShow: () => this.isXsView && this.userLoaded && (!this.user || !this.user.exists)
        },
        {
          name: 'Help',
          onClick: this.helpClick,
          icon: 'help',
          type: 'primary',
          shouldShow: () => this.isXsView || this.isSmView
        }]
        if (data && data.actions.length) {
          data.actions[data.actions.length - 1].divider = true;
          this.previewActionCell = {
            ...data,
            actions: [
              ...data.actions,
              ...defaultActions
            ],
          };
        } else {
          this.previewActionCell = {
            limit: 5,
            rowData: {},
            actions: defaultActions,
          };
        }
        this.cdr.detectChanges();
      });

      this.rootConfigSub = this.rootLayoutConfigService.currentData$.subscribe(data => {
        if (data?.linkTitle) {
          this.title = data.linkTitle;
        }
        if (data?.linkSubTitle) {
          this.subTitle = data.linkSubTitle;
        }
        this.showBackButton = data?.appBar?.showBackButton;
        this.cdr.detectChanges();
      })
  }
  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.sub1) {
      this.sub1.unsubscribe();
    }
    if (this.breakpointSub) {
      this.breakpointSub.unsubscribe();
    }
    if (this.actionsSub) {
      this.actionsSub.unsubscribe();
    }
    if (this.rootConfigSub) {
      this.rootConfigSub.unsubscribe();
    }
  }

  onHelpIconClick = () => {
    this.openHelpLinkDialog = true
  }

  updateAvatarInfo(updatedAvatarUrl: string) {
    this.avatarUrl = updatedAvatarUrl;
    this.avatarInfo = {
      type: 'avatar',
      size: this.avatarSize as any,
      url: this.avatarUrl,
      initials: this.avatarUrl
        ? ''
        : this.b64Pipe.transform(this.user?.display_name),
    };
  }

  onCommentReload = () => {
    // todo
  }

  helpClick = () => {
    this.openHelpLinkDialog = true;
    this.blendService.track(BlendEvent.HELP_EVENT);
  }

  openUserPanel = () => {
    if (this.isXsView) {
      this.bottomSheetComponent?.openBottomSheet();
    } else {
      this.isBottomSheetOpen = false;
      this.isUserPanelOpen = !this.isUserPanelOpen;
    }
  }

  closeUserPanel = () => {
    this.isUserPanelOpen = false;
  }

  toggleComment = () => {
    this.isCommentExpanded = !this.isCommentExpanded;
  }

  onBack = () => {
    window.history.back();
  }
  
  /**
   * this function updates css variables based on changes of this component's attributes
   */
  @HostBinding('attr.style')
  public get customColorsCss(): any {
    let  bgColor = this.primaryColor || 'var(--secondary-s-90)';
    let headerTextColor = this.textColor || 'var(--onsurface-onsurface)';
    let buttonBgColor = this.buttonPrimaryColor || 'var(--accentcolor-primary)';
    let buttonTextColor = this.buttonTextColor || 'var(--onaccent-onprimary)';
    let linkTextColor = this.linkColor || 'var(--accentcolor-primary)'; 
    
    if (this.colorService.colorsAreSimilar(headerTextColor, bgColor)) {
      headerTextColor = this.colorService.pickContrastColor(bgColor);
    }
    if (this.colorService.colorsAreSimilar(bgColor, buttonBgColor)) {
      buttonBgColor = headerTextColor;
    }
    if (this.colorService.colorsAreSimilar(buttonBgColor, bgColor)) {
      buttonBgColor = this.colorService.pickContrastColor(bgColor);
    }

    if (this.colorService.colorsAreSimilar(buttonTextColor, buttonBgColor)) {
      buttonTextColor = this.colorService.pickContrastColor(buttonBgColor);
    }

    if (this.colorService.colorsAreSimilar(linkTextColor, bgColor)) {
      linkTextColor = this.colorService.pickContrastColor(bgColor);
    }
    
    

    return this.sanitizer.bypassSecurityTrustStyle(`
    --headerPrimaryColor: ${bgColor};
    --headerTextColor: ${headerTextColor};
    --linkTextColor: ${linkTextColor};
    --primary-button-background-color: ${buttonBgColor};
    --primary-button-text-color: ${buttonTextColor};
  `);
  }
}